import "./App.css";
import { Route, Routes } from "react-router-dom";
import PublicRoutes from "./Components/Auth/PublicRoutes";
import ProtectedRoutes from "./Components/Auth/ProtectedRoutes";
import { protectedRoutes, publicRoutes } from "./Lib/Config/routes.config";
import AuthController from "./Controllers/AuthController";
import PageNotFound from "./View/404View";
import { Toaster } from "./Components/ui/toaster";
import { useAuth } from "./Lib/Hooks/AuthHooks";
import NotificationController from "./Controllers/NotificationController";
import { Suspense, useEffect } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

function App() {
  const { user, session } = useAuth();
  !user && AuthController.restorePersistedCredentials();

  useEffect(() => {
    if (!!user && !session?.fcm_token) {
      console.log(user, session, "for call notification");
      NotificationController.getFcmToken()
        .then((res) => {
          NotificationController.saveFcmToken(res);
          console.log("@token fcm....", res);
        })
        .catch((err) => {
          console.log("@token fcm err....", err);
        });
    }
  }, [user, !session?.fcm_token]);

  // !!user && NotificationController.onNotification();
  NotificationController.onNotification();

  return (
    <Suspense fallback={null}>
      <TransitionGroup>
        {/* <CSSTransition classNames="fade" timeout={10}> */}
        <>
          <Routes>
            <Route path="" element={<PublicRoutes />}>
              {publicRoutes.map((route) => (
                <Route
                  path={route.path}
                  key={route.key}
                  element={<route.component />}
                />
              ))}
            </Route>
            <Route path="" element={<ProtectedRoutes />}>
              {protectedRoutes.map((route) => (
                <Route
                  path={route.path}
                  key={route.key}
                  element={<route.component />}
                />
              ))}
            </Route>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          {/* <RouterProvider router={router} /> */}
          <Toaster />
        </>
        {/* </CSSTransition> */}
      </TransitionGroup>
    </Suspense>
  );
}

export default App;
